/* Normalize escaped newlines in the delivery app's asynchronously rendered copy. */
(() => {
  const normalize = () => {
    document.querySelectorAll('.cart .delivery-container .delivery-caution__statement, #cart-drawer .delivery-container .delivery-caution__statement').forEach((note) => {
      if (note.textContent.trim().startsWith('※置き配の場合')) note.classList.add('gm-unattended-delivery-note');
    });
    document.querySelectorAll('.cart .statement__wrapper--warning .statement__wrapper__title-block p, #cart-drawer .statement__wrapper--warning .statement__wrapper__title-block p').forEach((note) => {
      const text = note.textContent.trim();
      if (!/^※?都道府県を選択後に/.test(text)) return;
      note.closest('.statement__wrapper--warning').classList.add('gm-prefecture-note');
      if (!text.startsWith('※')) note.prepend('※');
    });
    document.querySelectorAll('.cart .delivery-caution__container, #cart-drawer .delivery-caution__container').forEach((notice) => {
      const walker = document.createTreeWalker(notice, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue.replace('※100cm角25mmのマットについて、原則、10枚以下の場合は通常宅配にて出荷しますので、日時指定をご希望の場合は備考欄に記載をお願いします（記載がない場合は最短日着にて手配します）。', '').replace(/\\r\\n|\\r|\\n/g, '\n');
        if (text.trimEnd() !== node.nodeValue) node.nodeValue = text.trimEnd();
      }
      notice.querySelectorAll('.delivery-caution__statement').forEach((statement) => {
        // The app may emit separate div/br nodes for the removed final paragraph.
        while (statement.lastChild && !statement.lastChild.textContent.trim()) {
          statement.lastChild.remove();
        }
      });
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; normalize(); });
  });
  document.querySelectorAll('#main-content, #cart-drawer').forEach((root) => observer.observe(root, { childList: true, subtree: true, characterData: true }));
  normalize();
})();
